<div class="overflow-x-auto">
    <table class="w-full text-left">
        <thead>
            <tr class="text-[14px] text-black bg-white">
                <th class="py-3 font-normal">Product</th>
                <th class="py-3 font-normal">EAN</th>
                <th class="py-3 font-normal text-center">Qty</th>
                <th class="py-3 font-normal text-center">Price</th>
                <th class="py-3 font-normal text-right">Subtotal</th>
            </tr>
        </thead>
        <tbody class="divide-y divide-gray-50">
            <tr *ngFor="let line of lines" class="text-[14px]">
                <td class="py-4">
                    <div class="flex items-center gap-3">
                        <div
                            class="w-12 h-12 border rounded-[6px] overflow-hidden flex-shrink-0"
                            style="border-color: var(--color-border-subtle)"
                        >
                            <img
                                *ngIf="line.featuredAsset; else noImage"
                                [src]="line.featuredAsset | assetPreview : 'thumb'"
                                class="w-full h-full object-cover"
                                [alt]="line.productVariant.name"
                            />
                            <ng-template #noImage>
                                <div class="w-full h-full bg-gray-50 flex items-center justify-center text-[8px] text-gray-300">
                                    No Image
                                </div>
                            </ng-template>
                        </div>
                        <div class="max-w-[200px]">
                            <p class="font-medium text-gray-900 leading-tight">
                                {{ line.productVariant.name | titlecase }}
                            </p>
                        </div>
                    </div>
                </td>
                <td class="py-4 text-gray-900">{{ line.productVariant.product.customFields.gtin }}</td>
                <td class="py-4 text-gray-900 text-center">{{ line.quantity }}</td>
                <td class="py-4 text-gray-900 text-center">
                    <span *ngIf="isDiscounted(line)" class="text-gray-400 line-through mr-1">{{ line.unitPriceWithTax | formatPrice }}</span>
                    {{ (isDiscounted(line) ? line.discountedUnitPriceWithTax : line.unitPriceWithTax) | formatPrice }}
                </td>
                <td class="py-4 text-gray-900 text-right font-medium">
                    <div class="flex flex-col items-end gap-0.5">
                        <span *ngIf="isDiscounted(line)" class="text-[12px] text-gray-400 line-through font-normal">{{ line.linePriceWithTax | formatPrice }}</span>
                        <span>{{ (isDiscounted(line) ? line.discountedLinePriceWithTax : line.linePriceWithTax) | formatPrice }}</span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
